import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { RoleDetailContainer } from '../components/role-detail.container';
import { SubPageLayout } from '../sub-page-layout';
import { Helmet } from 'react-helmet';

export const RoleDetails: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Role - Detail</title>
      </Helmet>

      <SubPageLayout
        header={
          <PageHeader
            title={<Typography.Title style={{ paddingBottom: '0px', fontSize: '30px', marginTop: '12px' }}>Role Details</Typography.Title>}
            onBack={() => navigate(-1)}
          ></PageHeader>
        }
      >
        <RoleDetailContainer />
      </SubPageLayout>
    </>
  );
};
